export const syncVariablesFromNodes = ({ nodes = {}, variables = {} }) => {
  const next = {};
  const walk = (map) => {
    Object.values(map).forEach((node) => {
      if (node.source?.kind === "data" && node.source.variable) {
        const key = node.source.variable;
        next[key] = {
          ...(variables[key] || {}),
          label: node.name,
          type: node.type === "image" ? "image" : "string",
          required: false,
          editable: true,
        };
      }
      if (node.children) walk(node.children);
    });
  };
  walk(nodes);
  return next;
};

export const syncVariablesFromArtboards = ({
  artboards = {},
  nodes = {},
  variables = {},
}) => {
  const next = {};
  const ingest = (tree) => {
    Object.assign(
      next,
      syncVariablesFromNodes({
        nodes: tree || {},
        variables: { ...variables, ...next },
      })
    );
  };
  Object.values(artboards || {}).forEach((artboard) => ingest(artboard?.nodes));
  ingest(nodes);
  return next;
};

export const listNodeVariables = ({ nodes = {} }) =>
  Object.entries(syncVariablesFromNodes({ nodes, variables: {} })).map(
    ([key, meta]) => ({
      key,
      label: meta?.label || key,
      type: meta?.type === "image" ? "image" : "string",
    })
  );

export const getArtboardVariableMismatches = ({ artboards = {} }) => {
  const entries = Object.entries(artboards || {});
  if (entries.length <= 1) return [];

  const perArtboard = entries.map(([artboardID, artboard]) => ({
    artboardID,
    variables: listNodeVariables({ nodes: artboard?.nodes }),
  }));

  const requiredKeys = new Set();
  const labelByKey = {};
  const typeByKey = {};
  perArtboard.forEach(({ variables }) => {
    variables.forEach(({ key, label, type }) => {
      requiredKeys.add(key);
      if (!labelByKey[key]) labelByKey[key] = label;
      if (!typeByKey[key]) {
        typeByKey[key] = type === "image" ? "image" : "text";
      }
    });
  });

  return perArtboard
    .map(({ artboardID, variables }) => {
      const present = new Set(variables.map((item) => item.key));
      const missing = [...requiredKeys]
        .filter((key) => !present.has(key))
        .sort((left, right) => left.localeCompare(right))
        .map((key) => ({
          key,
          label: labelByKey[key] || key,
          type: typeByKey[key] === "image" ? "image" : "text",
        }));
      return missing.length > 0 ? { artboardID, missing } : null;
    })
    .filter(Boolean);
};
